var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOnekey = function SvgOnekey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3105_80246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 27.0458 27.0458 32 16 32C4.95431 32 0 27.0458 0 16C0 4.95431 4.95431 0 16 0C27.0458 0 32 4.95431 32 16Z",
    fill: "#44D62C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4456 6.78467H12.9945L12.2136 9.14578H14.6858V14.1196H17.4456V6.78467Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0764 20.1391C21.0764 22.9426 18.8035 25.2153 16 25.2153C13.1964 25.2153 10.9238 22.9426 10.9238 20.1391C10.9238 17.3355 13.1964 15.0629 16 15.0629C18.8035 15.0629 21.0764 17.3355 21.0764 20.1391ZM18.7718 20.1391C18.7718 21.67 17.5309 22.9109 16 22.9109C14.4693 22.9109 13.2284 21.67 13.2284 20.1391C13.2284 18.6084 14.4693 17.3673 16 17.3673C17.5309 17.3673 18.7718 18.6084 18.7718 20.1391Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3105_80246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};

export { SvgOnekey as ReactComponent };
export default __webpack_public_path__ + "3546af533b1e9b6577f15ed96acbaf5a.svg";